import React from 'react';
import PropTypes from 'prop-types';

  export default function InfoHeader ({ title, id, execution }) {
    return (
    <div className="info-header d-flex justify-content-between align-items-center flex-wrap">
      <div className="d-flex align-items-center mb-2 mb-md-0">
        <h2 className="title mb-0">{title}</h2>
        {id && <span className="id-badge ms-2">{id}</span>}
      </div>
      <div className="score-metrics">
        <span className="score-label me-2">Overall</span>
        <span className={`score-value grade-${Math.round(execution)}`}>{execution}</span>
      </div>
    </div>
  );
}
  InfoHeader.propTypes = {
    title:PropTypes.string, id:PropTypes.oneOfType([PropTypes.string,PropTypes.number]), execution:PropTypes.number
  };
